import React, { useEffect } from "react";
import "./ComplianceResources.css";
import buildingimage from "../../images/building-bg.png";
import buildingimagesecond from "../../images/building-bg-right.png";
import circleleft from "../../images/circle-left-bg.png";
import circleright from "../../images/circle-right-bg.png";
import FooterComponent from "../../Pages/Footer/Footer";
import HeaderComponent from "../../Pages/Header/Header";
import { useNavigate } from "react-router-dom";
function ComplianceResources() {
    const navigate = useNavigate()
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top
    }, []);
    return (
        <>
            <HeaderComponent />
            <section className="one hoa-page-section">
                <div className="container">
                    {/* <HeaderComponent /> */}
                    <div className="banner-content">
                        <h1 className="text-center m-0 title-main">
                            Welcome to HOA Verified
                        </h1>
                        <p className="text-center hoa-subtitle">
                            The leading AI-powered platform for Homeowners' Associations (HOAs), property managers, and real estate professionals. Our mission is to simplify compliance, enhance transparency, and provide instant access to HOA-related resources using cutting-edge AI technology.
                        </p>
                        <div className="hz-line"></div>
                    </div>
                </div>
                <div className="building-block-left">
                    <img src={buildingimage} alt="building-pic"></img>
                </div>
                <div className="building-block-right">
                    <img src={buildingimagesecond} alt="building-pic"></img>
                </div>
            </section>
            <section className="two text-center hoa-section-two realtors-brokerages-section">
                <div className="container">
                    <div className="streamline-content">
                        <h2>Understanding HOA Compliance</h2>
                        <div className="circle-left">
                            <img src={circleleft} alt="circle-img"></img>
                        </div>
                    </div>
                </div>
            </section>
            <section className="Compliance-section">
                <div className="compliance-wrapper">
                    <div className="compliance-inner-boxes">
                        <div className="accordion" id="accordionPanelsStayOpenExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                        What is HOA Compliance?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        HOA compliance refers to the adherence to community rules, bylaws, and state regulations that govern homeowners' associations. Ensuring compliance helps maintain property values, community harmony, and legal standing.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                                        Why is Compliance Important for HOAs?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>Prevents legal disputes and fines</li>
                                            <li>Ensures fairness in enforcement of community rules</li>
                                            <li>Maintains property values and neighborhood appeal</li>
                                            <li>Keeps residents informed and engaged</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                        What are Common HOA Compliance Issues?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>Architectural and landscaping violations</li>
                                            <li>Short-term rental restrictions</li>
                                            <li>Parking and vehicle regulations</li>
                                            <li>Pet policies and breed restrictions</li>
                                            <li>Noise and nuisance complaints</li>
                                            <li>Collection and enforcement of dues and assessments</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="compliance-ques"></div>
                        <p className="m-0 compliance-para"></p>
                    </div>
                </div>
            </section>
            <section className="two text-center hoa-section-two realtors-brokerages-section">
                <div className="container">
                    <div className="streamline-content">
                        <h2>AI-Powered Compliance with HOA Verified</h2>
                    </div>
                </div>
            </section>
            <section className="Compliance-section">
                <div className="compliance-wrapper">
                    <div className="compliance-inner-boxes">
                        <div className="accordion" id="accordionPanelsStayOpenExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOnee" aria-expanded="true" aria-controls="panelsStayOpen-collapseOnee">
                                        How Does HOA Verified Help with Compliance?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOnee" className="accordion-collapse collapse">

                                    <div className="accordion-body">
                                        <p>HOA Verified integrates AI technology to:</p>
                                        <ul>
                                            <li>Automatically review governing documents for compliance gaps</li>
                                            <li>Monitor and update rules based on changing state laws</li>
                                            <li>Provide instant answers to compliance questions via Oscar AI</li>
                                            <li>Allow property managers to securely upload and organize documents</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwoo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwoo">
                                        How Does Oscar AI Improve HOA Management?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwoo" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <p>Oscar AI is embedded in secured homeowners' portals, providing:</p>
                                        <ul>
                                            <li>Instant access to governing documents and community rules</li>
                                            <li>Real-time responses to homeowner questions</li>
                                            <li>Automated compliance monitoring and recommendations</li>
                                            <li>Community news updates, including policy changes and amenity improvements</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="two text-center hoa-section-two realtors-brokerages-section">
                <div className="container">
                    <div className="streamline-content">
                        <h2>Resources for HOAs, Property Managers & Realtors</h2>
                    </div>
                </div>
            </section>
            <section className="Compliance-section">
                <div className="compliance-wrapper">
                    <div className="compliance-inner-boxes">
                        <div className="accordion" id="accordionPanelsStayOpenExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOneee" aria-expanded="true" aria-controls="panelsStayOpen-collapseOneee">
                                        How Can Property Managers Benefit from HOA Verified?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOneee" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>Reduced administrative workload with automated document retrieval</li>
                                            <li>Customizable document portal for public and private files</li>
                                            <li>Improved homeowner satisfaction with 24/7 AI-powered assistance</li>
                                            <li>Access to local service providers and exclusive vendor deals</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwooo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwooo">
                                        What Resources Are Available for Homeowners?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwooo" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>Community rules and regulations lookup</li>
                                            <li>AI-powered HOA compliance assessments</li>
                                            <li>Access to trusted real estate professionals and service providers</li>
                                            <li>Updates on HOA policy changes and community improvements</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThreee" aria-expanded="false" aria-controls="panelsStayOpen-collapseThreee">
                                        How Does HOA Verified Support Realtors?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThreee" className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <ul>
                                            <li>Provides real-time community information for homebuyers</li>
                                            <li>Allows agents to showcase property listings within community profiles</li>
                                            <li>Connects buyers with accurate HOA fee structures and restrictions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="two text-center hoa-section-two realtors-brokerages-section">
                <div className="container">
                    <div className="streamline-content">
                        <h2>Get Started with HOA Verified</h2>
                        <p>Interested in streamlining compliance and enhancing your HOA's efficiency? Contact us to learn more about how HOA Verified and Oscar AI can transform your community management.</p>
                        <div className="d-flex gap-3 align-items-center justify-content-center">
                            {/* <div className="demo-contact-us"><Link to="/Contact">[Contact Us]</Link></div> */}
                            <div className="text-start">
                                <button className="btn btn-outline get-started" type="submit" onClick={() => navigate("/signupone")}>
                                    Contact Us
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="#222222"
                                    >
                                        <g id="arrow-right-up-line">
                                            <path
                                                id="Vector"
                                                d="M13.9137 10.7054L3.77688 11.0594L3.71871 9.39376L13.8555 9.03977L9.23227 4.72853L10.3689 3.50961L17.073 9.76124L10.8213 16.4653L9.60241 15.3287L13.9137 10.7054Z"
                                                fill=""
                                            ></path>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                            {/* <div>|</div> */}
                            {/* <div className="demo-contact-us"><a href="">[Request a Demo]</a></div> */}
                        </div>
                        <div className="circle-right">
                            <img src={circleright} alt="circle-img"></img>
                        </div>
                    </div>
                </div>
            </section>
            <FooterComponent />
        </>
    );
}

export default ComplianceResources;
